import React from "react";

const FeatureSection: React.FC = () => {
    return (
        <section className="feature-section section-padding" id="nase-zameranie">
            <div className="container text-center">
                <div className="col col-lg title-container">
                    <h2 className="section-title">OSOBNÝ PROFIL</h2>
                </div>
                <div className="bio-text">
                    <p>
                        Som púchovský rodák, otec rodiny a človek, ktorého život formoval vrcholový šport, zahraničné skúsenosti a práca v komunálnej politike. 
                    </p>
                    <p>
                        Púchov je mojím domovom, miestom, kde mám hlboké korene a ku ktorému cítim úprimnú zodpovednosť. Ako bývalý profesionálny futbalista viem, čo znamená disciplína, tímová práca a ťah na bránu. Tieto vlastnosti, spolu so skúsenosťami z riadenia mestského športového klubu MŠK Púchov a pôsobenia v pozícii poslanca, chcem ponúknuť Vám, občanom Púchova. 
                    </p>
                    <p>Moja vízia je jasná: viesť mesto slušne, pokojne, bez konfliktov a s rešpektom voči každej generácii.</p>
                </div>
            </div>
        </section>
    );
};

export default FeatureSection;
